export const HRM_APP_STORE_URL = "https://apps.apple.com/app/id6449731905";
export const HRM_PRODUCTION_URL = "https://welcome.mypnoe.com/hrm";
export const HRM_STAGING_URL = "https://welcome-staging.mypnoe.com/hrm";

export const getHrmUniversalLink = (hostname: string): string =>
  hostname.toLowerCase() === "welcome-staging.mypnoe.com"
    ? HRM_STAGING_URL
    : HRM_PRODUCTION_URL;

export const getHrmSmartAppBannerContent = (hostname: string): string =>
  `app-id=6449731905, app-argument=${getHrmUniversalLink(hostname)}`;

export type HrmClientDevice = {
  userAgent: string;
  platform: string;
  maxTouchPoints: number;
};

export const isAppleMobileDevice = ({
  userAgent,
  platform,
  maxTouchPoints,
}: HrmClientDevice): boolean => {
  const isClassicAppleMobileDevice = /iPhone|iPad|iPod/i.test(userAgent);
  const isModernIPadDesktopMode = platform === "MacIntel" && maxTouchPoints > 1;

  return isClassicAppleMobileDevice || isModernIPadDesktopMode;
};

export const getHrmFallbackDestination = (
  device: HrmClientDevice
): string | null => (isAppleMobileDevice(device) ? HRM_APP_STORE_URL : null);
